import React from 'react';
import { Form, Modal } from 'react-bootstrap';
import "../../../../assets/css/react-datetime.css";
import ReactJson from 'react-json-view'
import { Heading6 } from '../../widgets';

const EGInfo = (props) => {
    const { egInfo } = props;
    const name = egInfo ? egInfo.name.toString().toLowerCase().split(" ").join("_") : "unknown";
    const disposeForm = () => {
        props.onHide();
    }

    return (<Modal show={props.show} onHide={disposeForm} backdrop="static" className="modal-form">
        <Form className="eg-form m-1">
            <Modal.Header closeButton>
                <Modal.Title>
                    <Heading6>
                        {egInfo && egInfo.name} Info
                    </Heading6>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-0">
                <ReactJson displayObjectSize={false} displayDataTypes={false} name={name} src={egInfo} />
            </Modal.Body>

        </Form>
    </Modal >)
}

export default EGInfo